export default "__VITE_ASSET__C_dF$KBP__"